import {
  createDetailType2ResponseSchema,
  createListResponseSchema
} from 'src/feature/bite/domain'
import z from 'zod'

export const ItemListItemSchema = z.object({
  itemCategory: z.string().optional().nullable(),
  itemCategoryID: z.string().optional().nullable(),
  itemID: z.string().optional().nullable(),
  name: z.string().optional().nullable(),
  paymentLink: z.boolean().optional().nullable(),
  directSale: z.boolean().optional().nullable(),
  eStore: z.boolean().optional().nullable(),
  status: z.number().optional().nullable(),
  isEditable: z.boolean().optional().nullable(),
  paymentLinkEnable: z.boolean().optional().nullable(),
})

export const ItemCategoryItemSchema = z.object({
  id: z.string(),
  name: z.string(),
  status: z.number(),
  productCategoryID: z.string().optional().nullable(),
})

export const ItemListSchemaResponse = createListResponseSchema(ItemListItemSchema.array())
export const ItemCategoryListSchemaResponse = createDetailType2ResponseSchema(
  ItemCategoryItemSchema.array()
)

export type ItemListItem = z.infer<typeof ItemListItemSchema>
export type ItemList = z.infer<typeof ItemListSchemaResponse.shape.response>
export type ItemListResponse = z.infer<typeof ItemListSchemaResponse>

export type ItemCategoryItem = z.infer<typeof ItemCategoryItemSchema>
export type ItemCategoryList = z.infer<typeof ItemCategoryListSchemaResponse.shape.response>
export type ItemCategoryListResponse = z.infer<typeof ItemCategoryListSchemaResponse>

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number().optional(),
    childFilters: z.array(z.object({})).optional(),
  })
)

const orderListSchema = z.array(
  z.object({
    type: z.number().optional().nullable(),
    typ: z.number().optional().nullable(),
    key: z.string(),
  })
)

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number(),
  totalCount: z.number().optional(),
})

const searchSchema = z.object({
  value: z.string(),
  keyList: z.array(z.string()),
})

export const listFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
  // search: searchSchema
})

export type ListFilter = z.infer<typeof listFilterSchema>
